import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme)=>({
    Grid:{
        marginTop:'2rem'
    }
}));

export default useStyles;